import { combineReducers } from "redux";
import { AppReducer } from "./App/AppReducer";
import { AuthReducer } from "./Auth/AuthReducer";

const rootReducer = combineReducers({
  app: AppReducer,
  auth: AuthReducer,
});

export default rootReducer;
